import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import { GetMeUsersParams, GetMeUsersResponse } from "api/api/usersApi/types";
import axios from "axios";

export const getMeUsers = createAsyncThunk<GetMeUsersResponse, GetMeUsersParams>(
  "users/getMeUsers",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.getMeUsers(params);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting users profile details", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting users profile details", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);